export const currentTableData = (array, currentPage, perPage) => {
  if (array) {
    const firstPageIndex = (currentPage - 1) * perPage;
    const lastPageIndex = firstPageIndex + perPage;
    return array.slice(firstPageIndex, lastPageIndex);
  }

  return 0;
};
